import React from 'react'
import Page from 'layout/access-management/page'
import PageTitle from 'layout/page-title'
import SettingsPanels from './panels'

// Settings within the Access Management app shell — lets an Access
// Management-only user reach the same organization/user settings.
const AccessManagementSettings = () => (
  <Page title="Settings">
    <PageTitle />
    <SettingsPanels />
  </Page>
)

export default AccessManagementSettings
